<template>
  <h1
    class="
      min-h-[100px]
      bg-primary
      font-bold
      py-4
      text-white text-3xl flex items-center justify-start
    "
  >
    {{ title }}
  </h1>
</template>
<script>
export default {
  props: {
    title: String,
  },
};
</script>
